/**
 * @description Type guard to check if a value is a string.
 * @param value
 */
export const isString = (value: unknown): value is string => {
  return typeof value === 'string';
};

/**
 * @description Type guard to check if a value is a non-empty string.
 * @param value
 */
export const isNonEmptyString = (value: unknown): value is string => {
  return isString(value) && value.trim() !== '';
};
